import { Button, Checkbox, Col, Form, Input, InputNumber, Pagination, Row, Select, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';

const columns = [
  {
    title: 'Tax Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => (
      <Badge className={record.active === true ? "text-green-950 bg-green-100 w-max" : "text-red-950 bg-red-100 w-max"}>{record.active ? 'active': 'archived'}</Badge>
    )
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/taxes/'+record.seo}>
        EDIT
      </Link>
    )
  }
]

// const taxes = [
//   {name: 'Purchase Taxes', type: 'purchase', amount: 10, active: 'active'},
//   {name: 'Sales Taxes', type: 'sales', amount: 10, active: 'active'},
//   {name: 'Customer Discount Taxes', type: 'sales', amount: 10, active: 'Inactive'},
//   {name: 'Product Purchase Taxes', type: 'purchase', amount: 10, active: 'active'},
//   // {name: 'Purchase Taxes', type: 'purchase', amount: 10, active: 'active'},
//   // {name: 'Purchase Taxes', type: 'purchase', amount: 10, active: 'active'},
//   // {name: 'Purchase Taxes', type: 'purchase', amount: 10, active: 'active'},
// ];


const Taxes = () => {
  const taxes = useLoaderData();
  const navigate = useNavigate();


  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/accounting/taxes/'+record.seo)
    };
  }
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Taxes</h3>
        <div className=' bg-white dark:bg-gray-900'>
          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/taxes/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={taxes}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default Taxes;